import z from "zod";

import { BusinessSchema } from "./business";
import { ShiftSchemaResponse } from "./shift";
import { ProfileSchema } from "./profile";

export const OfferSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
  id: z.number(),
  shift: ShiftSchemaResponse, // always present
  business: BusinessSchema, // always present
  userId: z.string(),
  offeredBy: z.string().nullable(),
  message: z.string().nullable(),
  unit: z.string().nullable(),
  business_id: z.number(),
  offer_status: z
    .enum(["PENDING", "ACCEPTED", "REJECTED", "WITHDRAWN"])
    .nullable(),
  unit_rate: z.number().nullable(),
  interest_status: z
    .enum(["PENDING", "ACCEPTED", "REJECTED", "WITHDRAWN"])
    .nullable(),
});

export type Offer = z.infer<typeof OfferSchema>;

export const OfferListResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean().default(false),
  offers: z.array(OfferSchema),
  total: z.number(),
  users: z.record(z.string(), ProfileSchema).nullable(),
});

export type OfferListResponse = z.infer<typeof OfferListResponseSchema>;
